import { FocusEventHandler, forwardRef, useEffect, useState } from "react";
import { useGetAziende, NodoDto, useGetAziendePortale } from "@/api";
import { AsyncAutocomplete } from "../../elements/Autocomplete";
import { portaleConfig } from "@/portaliConfig";

const AziendaPicker = forwardRef(
  (
    {
      value: _value,
      onChange,
      onBlur,
      name,
      placeholder,
      size,
      type
    }: {
      value?: NodoDto | { id: number } | null | undefined;
      onChange?: (
        event: React.SyntheticEvent | null,
        value: NodoDto | null | undefined
      ) => void;
      onBlur?: FocusEventHandler;
      name?: string;
      placeholder?: string;
      size?: "small" | "medium";
      type: "aziende"|"aziendePortale";
    },
    ref
  ) => {
    const { data: aziendeAll } = useGetAziende({
      query: {
        enabled: type === 'aziende'
      }
    });
    const { data: aziendePortale } = useGetAziendePortale(portaleConfig.id, {
      query: {
        enabled: type==='aziendePortale'
      }
    });

    const aziende = type === 'aziende' ? aziendeAll : aziendePortale;


    const value =
      _value && aziende?.data
        ? aziende.data.find((x) => x.id === _value.id)
        : null;

    return (
      <>
        <AsyncAutocomplete<NodoDto>
          ref={ref}
          onChange={onChange}
          fetchOptions={useGetAziende}
          getOptionLabel={(azienda) => azienda.nome}
          value={value}
          onBlur={onBlur}
          name={name}
          placeholder={placeholder}
          size={size}
        />
      </>
    );
  }
);

export default AziendaPicker;
